import { SavedSearchOperator } from "@north-beam/nb-client-side";

export const SavedSearchOperatorLabels = {
  [SavedSearchOperator.contains]: "Contains",
  [SavedSearchOperator.does_not_contain]: "Does not contain",
  [SavedSearchOperator.is]: "Is",
  [SavedSearchOperator.is_not]: "Is not",
  [SavedSearchOperator.starts_with]: "Starts with",
  [SavedSearchOperator.ends_with]: "Ends with",
} as const;

export const savedSearchOperatorOptions = () => {
  return Object.values(SavedSearchOperator).map((value) => ({
    label: SavedSearchOperatorLabels[value],
    value,
  }));
};
